import { getImageSizes, getSrcSet } from "../../Helpers/WindowHelpers";
import VariantInterface from "../../Interfaces/VariantInterface";
import { Field } from "formik";

interface ColorInterface {
    name: string,
    checked: boolean,
    index: number,
    variant: VariantInterface,
    onChange: (e: Event) => void
}

const Color = ({ name, checked, index, variant, onChange }: ColorInterface) => {
    return (

        <div className="material-tiles__wrapper">
            <Field
                name={name}
                type="radio"
                value={variant.id}
                checked={checked}
                onChange={onChange}
                className="material-tiles__input visually-hidden"
                id={`${name}-${variant.id}-${index}`}
            ></Field>
            <label htmlFor={`${name}-${variant.id}-${index}`} className={`material-tiles__tile ${variant.available ? '' : 'disabled'} ${checked ? 'is-active' : ''} ${parseInt(variant.price) > 0 ? 'is-upsell' : ''}`} aria-label={variant.image.alt}>
                <span className="visually-hidden">{variant.title}</span>
                <div className="material-tiles__tile--inner">
                    <img
                        className="d--block"
                        srcSet={getSrcSet(variant.image.src, [120, 240])}
                        sizes={getImageSizes('120px', [])}
                        alt={variant.image.alt}
                        loading="lazy"
                        role="presentation"
                    />
                </div>
            </label>
        </div>
    );
};

export default Color;